/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable global-require */
/* eslint-disable import/no-dynamic-require */
import { connect } from 'react-redux'
import apiRequestTypesMap from '../../enums/apiRequestTypesMap'

import * as actionCreators from '../../store/actions'
import { mapStateToProps } from '../../utils'
import { JujoGenericFormComponent } from './generic_form'

export class JujoEditComponent extends JujoGenericFormComponent {
  specializedFields = fields => fields.update

  specializedFieldGroups = fieldsGroup => fieldsGroup.update || []

  specializedApiDef = apis => apis.updateData

  specializedApiRequestType = () => apiRequestTypesMap.put
}

export default connect(mapStateToProps, actionCreators)(JujoEditComponent)
